import {chevronLeftCircleSvg as Icon__small__chevronLeftCircleSvg} from '../Icon__small/Icon__small--chevronLeftCircle.js';

export var chevronLeftCircle = {
  name: 'chevronLeftCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__chevronLeftCircleSvg,
};
